import {EncryptedDataActionTypes, EncryptedDataState, encryptedData, EncryptedDataCreateAction} from "../../types/Encryption/encryption";

const initialEncryptedData: encryptedData = {
    rtag: ''
};

const initialState: EncryptedDataState = {
    encryptedData: initialEncryptedData,
    loadingEncryptedData: false,
    encryptedDataError: null,
};

export const encryptionReducer = (state = initialState, action: EncryptedDataCreateAction): EncryptedDataState => {
    switch (action.type) {
        case EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA:
            return { ...state, loadingEncryptedData: true, encryptedDataError: null, encryptedData: initialEncryptedData };
        case EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA_SUCCESS:
            return { ...state, loadingEncryptedData: false, encryptedDataError: null, encryptedData: action.payload };
        case EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA_ERROR:
            return { ...state, loadingEncryptedData: false, encryptedDataError: action.payload, encryptedData: initialEncryptedData };
        default:
            return state;
    }
};